//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
import "../CAM/CAM.CollisionConfigurationBuilder.js";
let d=[[[0,"AnalyzeMachiningTime",1,0],[0,"AnimationAccuracy",1,0],[0,"CacheNcProgram",1,0],[0,"CheckLimitViolation",1,0],[0,"CheckToolHolder",1,1],[0,"CheckToolHolderGougeCheck",1,0],[0,"CheckToolHolderIpw",1,0],[0,"ChordalTolerance",1,0],[1,"CollisionConfigurationBuilder",0,"CAM.CollisionConfigurationBuilder",0],[0,"Collshape",1,1],[0,"DetectAirCuttingTime",1,0],[0,"DisplayByTime",1,0],[0,"DisplayIpw",1,0],[0,"DisplayStationary",1,0],[0,"EnableCollision",1,1],[0,"EnableDisplay",1,1],[0,"EnableIpw",1,1],[0,"EnableMachineCollision",1,0],[0,"EnableMaterialRemoval",1,0],[0,"GougeTolerance",1,0],[0,"HideBlankGeometry",1,0],[0,"HidePartGeometry",1,0],[0,"HistoryBuffer",1,0],[0,"InterpretContactContour",1,0],[0,"IpwColor",1,0],[0,"IpwFeatureRefinement",1,0],[0,"IpwResolution",1,0],[0,"IpwUpdate",1,0],[0,"MaxAngularIncr",1,0],[0,"MaxLengthIncr",1,0],[0,"MaxTimeIncr",1,0],[0,"MinSimulationTime",1,0],[0,"Mrshape",1,1],[0,"SaveAsPartfile",1,0],[0,"SimulationDisplay",1,0],[0,"SkipAllLevels",1,0],[0,"StockSetting",1,0],[0,"StockValue",1,0],[0,"StopOnCollision",1,0],[0,"StopOnHistoryBuffer",1,0],[0,"StopOnLimitViolation",1,0],[0,"StopOnM1",1,0],[0,"StopOnRapidThroughIpw",1,1],[0,"ToolIpwCollision",1,0],[0,"ToolPartCollision",1,0],[0,"ToolShape",1,1],[0,"ToolTraceDragging",1,0],[0,"ToolTraceLowerVelocityThreshold",1,0],[0,"ToolTraceModeValue",1,0],[0,"ToolTraceSize",1,0],[0,"ToolTraceUpperVelocityThreshold",1,0],[0,"TranslucencyValue",1,0]],[[["nLevel"],"GetSkipLevel",{R_:{pbValue:''}},1,0],[["nLevel","bValue"],"SetSkipLevel",{},2,0]],[]];
SPLM.CAM.SimulationOptionsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.SimulationOptionsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.SimulationOptionsBuilder.DialogType = Object.freeze({
    "Simulate" : "Simulate", "MachineToolBuilder" : "MachineToolBuilder", "Synchronize" : "Synchronize", "Inspection" : "Inspection"});

SPLM.CAM.SimulationOptionsBuilder.SimulationDisplayMode = Object.freeze({
    "SuppressAll" : "SuppressAll", "SuppressGraphics" : "SuppressGraphics", "All" : "All"});

SPLM.CAM.SimulationOptionsBuilder.ToolTraceMode = Object.freeze({
    "MotionType" : "MotionType", "Acceleration" : "Acceleration", "Velocity" : "Velocity"});

SPLM.CAM.SimulationOptionsBuilder.Enable = Object.freeze({
    "No" : "No", "Yes" : "Yes"});

SPLM.CAM.SimulationOptionsBuilder.IpwEnable = Object.freeze({
    "Off" : "Off", "MotionBased" : "MotionBased", "LengthIncrement" : "LengthIncrement"});

SPLM.CAM.SimulationOptionsBuilder.IpwUpdateMode = Object.freeze({
    "MotionBased" : "MotionBased", "LengthIncrement" : "LengthIncrement"});

SPLM.CAM.SimulationOptionsBuilder.Stationary = Object.freeze({
    "Eath" : "Eath", "Part" : "Part", "Tool" : "Tool"});

SPLM.CAM.SimulationOptionsBuilder.Resolution = Object.freeze({
    "Fast" : "Fast", "Normal" : "Normal", "Fine" : "Fine", "ExtraFine" : "ExtraFine"});

SPLM.CAM.SimulationOptionsBuilder.Accuracy = Object.freeze({
    "Fine" : "Fine", "Coarse" : "Coarse"});

SPLM.CAM.SimulationOptionsBuilder.ToolShapeColl = Object.freeze({
    "Unknown" : "Unknown", "Parameter" : "Parameter", "Assembly" : "Assembly"});

SPLM.CAM.SimulationOptionsBuilder.ToolShapeMR = Object.freeze({
    "Parameter" : "Parameter", "Assembly" : "Assembly"});

SPLM.CAM.SimulationOptionsBuilder.ToolShapeType = Object.freeze({
    "Parameter" : "Parameter", "Assembly" : "Assembly"});

SPLM.CAM.SimulationOptionsBuilder.StockType = Object.freeze({
    "Automatic" : "Automatic", "UserDefined" : "UserDefined"});

export default SPLM;